import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AbstractComponent } from '@shared/common/abstract.component';
import type { CallOutCharge } from '@shared/modules/rates/call-out-charge';
import { AppSnackBar } from '@shared/services/snackbar/app-snackbar.service';
import { clone } from '@shared/utils';
import { equals } from '@shared/utils/helpers';

@Component({
    selector: 'app-call-out-charges',
    styleUrls: ['./call-out-charges.component.scss'],
    template: `
        <div class="call-out-charges-container">
            <table class="call-out-charges-table" *ngIf="_callOutCharges && _callOutCharges.length > 0">
                <thead class="call-out-charges-heading">
                <tr>
                    <th>Description</th>
                    <th>Amount</th>
                </tr>
                </thead>
                <tbody>

                <tr *ngFor="let charge of _callOutCharges; let i = index" class="charge">
                    <td>
                        <app-input-text [(ngModel)]="charge.description"
                                        data-testid="input:call-out-charge-description"
                                        [required]="true" />
                    </td>
                    <td>
                        <app-input-currency placeholder="Amount"
                                            data-testid="input:call-out-charge-amount"
                                            floatLabel="never"
                                            appearance="standard"
                                            [(ngModel)]="charge.amount" />
                    </td>
                    <td>
                        <button cll-icon-button
                                cllTooltip="Delete charge"
                                (click)="deleteCharge(i)">
                            <cll-icon>clear</cll-icon>
                        </button>
                    </td>
                </tr>

                </tbody>
            </table>

            <div>
                <button cll-tonal-button
                        colour="variant"
                        data-testid=button:add-call-out-charge
                        cllTooltip="Add call out charge"
                        (click)="addCharge()">
                    Add charge
                    <cll-icon>add</cll-icon>
                </button>
            </div>

        </div>
    `,
})
export class CallOutChargesComponent extends AbstractComponent {
    _callOutCharges: CallOutCharge[];
    _callOutChargesOriginal: CallOutCharge[];

    @Input()
    set callOutCharges(value: CallOutCharge[]) {
        this._callOutCharges = value;
        this._callOutChargesOriginal = value;
    }

    @Output() callOutChargesChange = new EventEmitter<CallOutCharge[]>();

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private dialog: MatDialog,
        private snackBar: AppSnackBar,
    ) {
        super();
    }

    onModelChanged() {
        const previousCharges = clone(this._callOutChargesOriginal);
        const updatedCharges = clone(this._callOutCharges);


        const hasChanged = !equals(previousCharges, updatedCharges);

        if (hasChanged) {
            this.callOutChargesChange.emit(updatedCharges);
        }
    }

    addCharge() {
        if (!this._callOutCharges) {
            this._callOutCharges = [];
        }

        this._callOutCharges.push({
            description: '',
            amount: 0,
        });

        this.onModelChanged();
    }

    deleteCharge(index: number) {
        this._callOutCharges.splice(index, 1);

        this.onModelChanged();
    }
}
